import React from "react";
//#region redux
import { AppState } from "store";
//#endregion
//#region types
//#endregion
//#region components
import useWintCardPromotionDialog from "./useDialog";
import { useSelector } from "react-redux";
import { useCheckRelations } from "components/common";
//#endregion

const WintCardPopup: React.FC = (props) => {
  const allowWintCardRegistration = useSelector(
    (store: AppState) => store.auth.selectedCompany.allowWintCardRegistration
  );

  const { openDialog } = useWintCardPromotionDialog();
  const { getIsAdmin, getIsAuditor } = useCheckRelations();

  React.useEffect(() => {
    if (getIsAdmin() && !getIsAuditor() && allowWintCardRegistration) openDialog();
  }, [allowWintCardRegistration]);
  return <></>;
};

export default WintCardPopup;
